define('pages/media/media_page_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'modules/files/files_list_view',
  'modules/file_upload/upload_view',

  'modules/search_field/search_field_view',

  'modules/modal/modal_view',
  './upload_modal_view',

  'text!./media_page_template.html'

], function (Backbone, $, _,
             session,
             FilesView,
             UploadView,
             SearchFieldView,
             ModalView,
             UploadModalView,
             media_page_template) {
  'use strict';
  var View = Backbone.View.extend({

    initialize: function (options) {

      this.subViews = [];
      this.render();

      this.files = new FilesView({
        location_id: session.get('location_id')
      });
      this.subViews.push(this.files);

      this.searchField = new SearchFieldView({collection: this.files.collection});
      this.subViews.push(this.searchField);

      this.renderSubView();
    },

    template: _.template(media_page_template),
    subViews: [],

    events: {
      'click .js-add-media': 'addMedia'
    },

    render: function () {

      this.$el.html(this.template());
      return this;

    },

    renderSubView: function () {

      this.$('.media-page-content').html(this.files.$el);
      this.$('.search-field').html(this.searchField.$el);
    },

    addMedia: function () {
      this.showMediaModal();
      this.showUpload();
    },

    showMediaModal: function () {
      var mediaModal = new ModalView({
        title: _.t('modal.header.file_uploads'),
        modalContent: new UploadModalView()
      });

      mediaModal.open();
    },

    showUpload: function (evt) {
      var self = this;

      if (this.upload) {
        return;
      }

      this.upload = new UploadView({$target_el: this.$('.media-page-upload')});

      setTimeout(function () {
        self.$('.dropzone').addClass('open');
      }, 10);

      this.listenTo(this.upload, 'fileUploadComplete', function (fileModel) {
        // remove model from upload-collection
        fileModel.collection.remove(fileModel);

        // add file to file list
        self.files.addFile(fileModel);  
      });

    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

